import { TableRow, tableCellClasses, tableRowClasses } from '@/core/ui';
import { lighten, styled } from '@mui/material';
import { itemWorkflowTableHeaderHeight } from '@/shared/constants';
import { shouldNotForwardProps } from '@/shared/helpers';
import { getSelectedRowOutlineStyles } from './getSelectedRowOutlineStyles';
export const TableRowStyled = styled(TableRow, shouldNotForwardProps('rowState', 'selected'))(({ theme, rowState, selected }) => {
    const { palette: { success, yellow, error, primary, common, background }, } = theme;
    let color = common.white;
    let hoverColor;
    let borderColor = background.light;
    const coefficient = 0.3;
    switch (rowState) {
        case 'blocked':
            color = lighten(error.background, coefficient + 0.1);
            hoverColor = lighten(error.background, 0.1);
            borderColor = lighten(error.background, coefficient + 0.1);
            break;
        case 'complete':
            color = lighten(success.background, coefficient);
            hoverColor = lighten(success.lightest, 0.4);
            borderColor = lighten(success.background, coefficient);
            break;
        case 'incomplete':
            color = lighten(yellow.background, coefficient);
            hoverColor = lighten(yellow.lightest, 0.4);
            borderColor = lighten(yellow.background, coefficient);
            break;
        case 'disabled':
            color = lighten(background.light, coefficient);
            hoverColor = color;
            borderColor = lighten(background.light, coefficient);
            break;
        case null:
            hoverColor = lighten(primary.backgroundLight, 0.5);
            break;
        default: {
            const exhaustiveCheck = rowState;
            throw new Error(`Unhandled ItemWorkflowTableRowState case: ${exhaustiveCheck}`);
        }
    }
    const outlineStyles = selected ? getSelectedRowOutlineStyles(theme) : undefined;
    return {
        // Should be equal to table's header height.
        scrollMarginTop: itemWorkflowTableHeaderHeight,
        background: color,
        [`> .${tableCellClasses.root}`]: {
            // TODO: this style is duplicated all over the warehouse tables, check. Extract.
            padding: theme.spacing(2, 3.5),
            borderTopColor: borderColor,
            ...(rowState === 'disabled' && {
                color: theme.palette.text.translucent,
            }),
        },
        [`&.${tableRowClasses.hover}&:hover`]: {
            cursor: 'pointer',
            background: hoverColor,
            [`> .${tableCellClasses.root}`]: {
                borderTopColor: hoverColor,
            },
        },
        ...outlineStyles,
    };
});
